D.CaseStudies = {};

const SectionCaseStudies = Class(
	/**
	 * @lends {SectionCaseStudies#}
	 */
	{
		route() {
			const part = this.url.shift();
			if (part === String(parseInt(part))) {
				return new SectionCaseStudies.CaseStudiesItem;
			}
			return new SectionUnknown;
		}
	},
	Section
);

/**
 * @class
 * @extends Section
 */
SectionCaseStudies.Base = Class(
	/**
	 * @lends {SectionCaseStudies.Base#}
	 */
	{
		menuItem: 'case-studies',

		__construct() {
			this.node = mkE({
				tag: 'div',
				id: 'case-studies',
				className: 'SectionCaseStudies'
			}).append(this.layout.ct());
		}
	},
	Section
);

/**
 * @class
 * @extends SectionCaseStudies.Base
 */
SectionCaseStudies.CaseStudiesItem = Class(
	/**
	 * @lends {SectionCaseStudies.CaseStudiesItem#}
	 */
	{

		/** @type {DR.casestudies.Get} */
		_mGetItem: null,

		route() {
			this.id = +this.url.before;
		},

		draw() {
			mkE({
				tag: 'div',
				className: 'CaseStudiesItem',
				els: [
					this._itemNode = mkE({
						tag: 'div',
						className: 'container'
					}),
					new T.InstagramFeed(),
					{
						tag: 'div',
						className: 'container single-event-giftcards',
						els: [
							{
								tag: 'div',
								id: 'giftcards',
								els: [
									{
										tag: 'div',
										className: 'banner',
										els: [
											{tag: 'span', className: 'icon'},
											{tag: 'span', className: 'text', text: D.Lang.get('case-studies.giftcards.banner.text')},
											{
												tag: 'a',
												href: D.url('/gift-card/'),
												className: 'button button-turquoise',
												text: D.Lang.get('case-studies.giftcards.banner.button')
											},
											{tag: 'div', className: 'clear'}
										]
									}
								]
							}
						]
					}
				]
			}).append(this.node);

			this._mGetItem = new DR.casestudies.Get();
			this._mGetItem.id = this.id;
			this._mGetItem.select = [
				new DR.casestudies.select.Item().all(),
				new DR.roadgames.select.Image().all()
			];
			this._mGetItem.onLoad = this._mGetItemRe;
			this._mGetItem.onError = this._mGetItemErr;
			this.apiCall.addMethod(this._mGetItem);

			this.apiCall.call();
		},

		_mGetItemErr() {
			Section.navigate(D.url('/case-studies'));
		},

		_mGetItemRe() {
			let item = this._mGetItem.re;
			this.meta
				.setTitle(item.metaTitle || item.title)
				.setDescription(item.metaDescription)
				.setOgImage(item.cover.image.original)
				.setCanonical(item.url)
				.setAlternates(item.url, item.langs)
			new D.CaseStudies.Item(item).append(this._itemNode);
		}
	},
	SectionCaseStudies.Base
);

/**
 * @class
 * @param {DR.casestudies.struct.Item} item
 * @extends mkE.Base
 */
D.CaseStudies.Item = Class(
	/**
	 * @lends {D.CaseStudies.Item#}
	 */
	{
		/** @param {DR.casestudies.struct.Item} item */
		__construct(item) {
			this.item = item;
			this.node = mkE({
				tag: 'article',
				className: 'case-studies-item'
			});
			this.draw();
		},

		draw() {
			mkE({
				tag: 'header',
				els: [
					{
						tag: 'h1',
						className: 'title',
						text: this.item.title
					}
				]
			}).append(this.node);
			mkE({
				tag: 'section',
				className: 'wrapper',
				els: [
					{
						tag: 'section',
						className: 'body',
						els: [
							this.item.hasCover ? {
								tag: 'section',
								className: 'cover',
								els: [
									{
										tag: 'img',
										className: 'cover',
										src: this.item.cover.image.large
									}
								]
							} : '',
							{
								tag: 'section',
								className: 'ck-content',
								innerHTML: this.item.html
							}
						]
					}
				]
			}).append(this.node);
		}
	},
	mkE.Base
);
